import { AnimaliaDetailMapper, AnimaliaDetailPageDTO } from '../mappers/AnimaliaDetailMapper';
import { AnimaliaDetailRepositoryPort } from '../../domain/ports/AnimaliaDetailRepositoryPort';

export type FetchAnimaliaDetailResult =
  | {
      status: 'success';
      detail: AnimaliaDetailPageDTO;
    }
  | {
      status: 'not-found';
    };

export class FetchAnimaliaDetailUseCase {
  constructor(private readonly repository: AnimaliaDetailRepositoryPort) {}

  async execute(slug: string): Promise<FetchAnimaliaDetailResult> {
    const detail = await this.repository.fetchBySlug(slug);

    if (detail === null) {
      return {
        status: 'not-found',
      };
    }

    return {
      status: 'success',
      detail: AnimaliaDetailMapper.toPageDTO(detail),
    };
  }
}
